export * from "./brands";
export * from "./books";
export * from "./slides";
export * from "./publishing"
export * from "./testimonials"
export * from "./services"
export * from "./cards-icons"
export * from "./steps"
export * from "./vector-art"
export * from "./icons"
export * from "./pick-icons"
import Logo from "./new-logo.webp";
import LogoWhite from "./new-logo.webp";



export { Logo, LogoWhite };